<template>
    <dx-select-box
        :data-source="dataSource"
        :disabled="disabled"
        :display-expr="displayExpr"
        :showClearButton="true"
        :value="value"
        :value-expr="valueExpr"
        :drop-down-options="{ maxHeight: dropDownMaxHeight }"
        @contentReady="onContentReady"
        @opened="emit('opened')"
        @valueChanged="onValueChanged"
    />
</template>
<script setup>
import { DxSelectBox } from 'devextreme-vue';

const emit = defineEmits(['valueChanged', 'opened']);

defineProps({
    value: {
        default: null,
        type: [String, Number, null],
    },
    dataSource: {
        default: () => [],
        type: Array,
    },
    valueExpr: {
        default: 'id',
        type: String,
    },
    displayExpr: {
        default: 'name',
        type: String,
    },
    disabled: {
        type: Boolean,
        default: true,
    },
    dropDownMaxHeight: {
        type: String,
        default: '400',
    }
});

const onContentReady = e => {
    if (!e.component.__initDropDownContainer) {
        e.component.__initDropDownContainer = true;
        e.component.option('dropDownOptions.container', e.element.parentElement);
    }
};

const onValueChanged = event => {
    const selectedItem = event.component.option('selectedItem');
    const text = selectedItem ? selectedItem[event.component.option('displayExpr')] : null;
    emit('valueChanged', {
        value: event.value,
        text: text,
    });
};
</script>